import _JSON$stringify from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/json/stringify';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var querystring = require('querystring');
export default {
  props: ['datas', 'query', 'url'],
  data: function data() {
    if (this.query.pageNo === undefined) {
      this.query.pageNo = 1;
    }
    if (this.datas == null || this.datas.results.length === 0) {
      return {
        currentPage: 0,
        countPages: 0
      };
    }
    if (this.datas.totalRows === 0) {
      return {
        currentPage: 0,
        countPages: 0
      };
    }
    var pageSize = this.datas.pageSize || 50;
    var maxPage = 5;
    var countPages = Math.ceil(this.datas.totalRows / pageSize);
    var currentPage = parseInt(this.datas.pageNo);
    var isSplit = false;
    var loopPage = [];
    var remain = maxPage;
    var prePage = -1;
    var subPage = -1;
    var startText = (this.query.pageNo - 1) * pageSize + 1;
    var toText = startText + pageSize - 1;
    if (toText > this.datas.totalRows) {
      toText = this.datas.totalRows;
    }
    if (countPages > maxPage) {
      if (currentPage - 2 > 1) {
        prePage = currentPage - 3;
      }
      if (currentPage + 2 < countPages) {
        subPage = 1;
      }

      isSplit = true;
      var start = currentPage - 2;
      var left = 0;

      if (start <= 1) {
        left = start + 1;
      } else {
        left = start;
        if (left > 2) {
          left = 2;
        }
      }
      var remainRight = countPages - currentPage;
      if (remainRight < 2) {
        left += 2 - remainRight;
      }

      for (var i = left; i > 0; i--) {
        loopPage.push(currentPage - i);
        remain--;
      }

      loopPage.push(currentPage);
      remain--;

      for (var _i = 1; _i <= remain; _i++) {
        var assign = currentPage + _i;
        if (assign <= countPages) {
          loopPage.push(assign);
        }
      }
    } else {
      for (var _i2 = 0; _i2 < countPages; _i2++) {
        loopPage.push(_i2 + 1);
      }
    }

    // let max = 5

    return {
      prePage: prePage,
      maxPage: maxPage,
      subPage: subPage,
      startText: startText,
      toText: toText,
      currentPage: currentPage,
      countPages: countPages,
      loopPage: loopPage,
      isSplit: isSplit
    };
  },

  computed: {
    cal: function cal() {}
  },
  methods: {
    createUrl: function createUrl(pageNo) {
      var obj = JSON.parse(_JSON$stringify(this.query));
      obj.pageNo = pageNo;
      var urlQuery = querystring.stringify(obj);
      return this.url + '?' + urlQuery;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pagination.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pagination.vue
// module chunks = 18 19 20 21 22 23 24 25 26 27 28 39